<template>
    <div class="main_unit">
        <div class="top_unit">
            <div class="top_name_box">{{ getStaffName }}</div>
            <div class="top_center_box"> </div>
        </div>
        <div class="main_unit">
            <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
            <div class=" wd976 tbl_ht_none tbl_bg_blue" v-show="!isInitLoading">

                <div v-if="validationMessage">
                    <Message :validationMessage="alertMessage" /><br>
                    <Message :validationMessage="validationMessage" />
                </div>

                <table class="alert_tbl_unit_prm alert_tbl_unit_prm_height">
                    <tbody class="alert_tbl_unit_prm_scroll">
                        <tr>
                            <th class="wd140 alertList_text_align">コメント入力日時</th>
                            <th class="wd140 alertList_text_align">コメント記載者</th>
                            <th class="wd140 alertList_text_align">コメント種別</th>
                            <th class="wd140 alertList_text_align">コメント対象日</th>
                            <th class="wd335 alertList_text_align">コメント内容</th>
                            <th class="wd75 alertList_text_align">担当者</th>
                        </tr>
                        <tr v-for="(alertList,index) in alertListData" :key="index">
                            <td class="wd140 alertList_text_align text_white_space alert_table_background-color" style="padding-top: 20px;padding-bottom: 20px;">{{alertList.commentsDatetime}}</td>
                            <td class="wd140 alertList_text_align text_white_space alert_table_background-color" style="padding-top: 20px;padding-bottom: 20px;">{{alertList.managerType}}</td>
                            <td class="wd140 alertList_text_align text_white_space alert_table_background-color" style="padding-top: 20px;padding-bottom: 20px;">{{alertList.reportType}}</td>
                            <td class="wd140 alertList_text_align text_white_space alert_table_background-color" style="padding-top: 20px;padding-bottom: 20px;">{{alertList.checkDate}}</td>
                            <td class="wd335 alert_table_background-color" style="padding-top: 20px;padding-bottom: 20px;white-space: pre-wrap;min-width: 320px">{{alertList.comment}}</td>
                            <td class="wd75 alertList_text_align text_white_space alert_table_background-color" style="padding-top: 20px;padding-bottom: 20px;">
                              <input type="checkbox" name="checkbox02" :id="alertList.reportCommentAlertId" v-model="readIdList" :value="alertList.reportCommentAlertId">
                              <label class="checkbox02" :for="alertList.reportCommentAlertId"></label>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="btn_submit letter_spa">
                    <a href="#" role="button" @click.prevent.stop="sendCommentReadInput()" >登録</a>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s"></p>
                            <p class="modal_header_tit">報告書コメント通知詳細</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>報告書コメント対処の登録が完了しました。</p>
                    </div>
                    <div class="btn_submit_box">
                        <div class="btn_submit2">
                            <a role="button" @click.prevent.stop="closeModal()">閉じる</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>
</template>

<script>

    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'

    export default {
        name: 'ReportCommentAlertList',
        components: {
            PulseLoader,
            Message
        },
        computed:{
            brandPath: function () {
                return this.$store.getters['brand/path']
            },
            getStaffName:function () {
              return  this.$store.getters['staff/name'];
            },
        },
        data: function () {
            return {
                isInitLoading:true,
                validationMessage:"",
                alertMessage:'入力エラーがあります。',
                alertListData:[],
                showContent:false,
                isLoading:false,
                readIdList:[],
            }
        },
        mounted () {

        },
        created: function(){
            this.calc();
        },
        methods:{
            calc:async function(){

                this.isInitLoading = true;

                // 企業ブランドIDの取得
                this.brandId = this.$store.getters['brand/id']
                // 店舗IDの取得
                this.storeId = this.$store.getters['store/id']

                // DBデータ取得
                await this.$axios
                    .get(this.$apiEndpoint + 'user/brand/' + this.brandId + '/store/' + this.storeId + '/reportAlert')
                    .then(response => (this.alertListData = response['data']['reportCommentAlerts']))
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: 'top', params:{brandPath: this.brandPath}}
                            }}
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(()=> this.isInitLoading = false);
            },
            //更新処理
            async sendCommentReadInput(){

                this.isLoading = true;
                //バリデーションフラグ
                var validationFlg = true;
                //バリデーションチェック(桁数)
                this.validationMessage = '';
                var apiResponseFlg = true;
                // 企業ブランドIDの取得
                this.brandId = this.$store.getters['brand/id']
                // 店舗IDの取得
                this.storeId = this.$store.getters['store/id']
                // スタッフID
                var pkStaffId = this.$store.getters['staff/id'];


                // request作成
                var requestBody = {}
                var report_comment_alerts = [];

                this.alertListData.forEach(item => {
                  if(this.readIdList.includes(item.reportCommentAlertId)) {
                    report_comment_alerts.push(item);
                  }
                });
                if(report_comment_alerts.length == 0){
                  validationFlg = false;
                  this.validationMessage = 'コメントが選択されていません。';
                }
                if(!validationFlg){
                  this.isLoading = false;
                  //処理終了
                  return null;
                }
                requestBody.report_comment_alerts = report_comment_alerts;
                requestBody.pkStaffId = pkStaffId;
                var formRequestBody = this.jsonToFormData(requestBody);

                var config = {
                  headers: {
                    'Content-Type': 'multipart/form-data;'
                  }
                }
                // メニューページ情報更新API
                await this.$axios
                  .post(this.$apiEndpoint + 'user/brand/' + this.brandId + '/store/' + this.storeId + '/reportAlert', formRequestBody, config)
                  .catch((err) => {
                    let error = {
                      button: {
                        path: {name: 'top', params:{brandPath: this.brandPath}}
                      }}
                    apiResponseFlg = false;
                    if (err.customError) {
                      // APIのエラー情報をerrorに入れる
                      error = Object.assign(error, err.customError)
                      // エラーコードが400であればバリデーションエラーなので画面に表示する
                      if (error.code == 400) {
                        this.apivalidationMessage = error.message
                        this.scrollTop();
                      }
                    }
                    if (this.apivalidationMessage == '') {
                      this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }
                  }).finally(()=> this.isLoading = false);

                if(apiResponseFlg){
                  this.isLoading = false;
                  this.showContent = true;
                }
            },
            closeModal(){
                this.showContent = false;
                // 画面最新化
                this.calc();
            },
            scrollTop() {
                window.scrollTo(0,0);
            },
            buildFormData(formData, data, parentKey) {
              if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(key => {
                  this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                });
              } else {
                const value = data == null ? '' : data;

                formData.append(parentKey, value);
              }
            },
            jsonToFormData(data) {
              const formData = new FormData();

              this.buildFormData(formData, data);

              return formData;
            },
        }
    }
</script>

